<template>
  <div class="pay-discount">
    <div class="hd ly-card">
      <div class="fl">
        <el-button class="fl" type="primary" @click.native="exportExcel">导出</el-button>
        <advanced-query @search="search" size="medium" />
      </div>
      <div class="fr">
        <el-date-picker
          v-model="date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
        <el-input placeholder="学员/证件号/预约号/班级/操作员" v-model.trim="query"></el-input>
        <el-button @click="() => search()" type="primary">查询</el-button>
      </div>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :searchFormData="searchFormData"
      class="ly-card"
      ref="lyTable"
    >
      <template v-slot:reservation_number="row">
        <el-button type="text" class="reservation-number" size="small" @click="() => openInf(row)">{{
          row.reservation_number
        }}</el-button>
      </template>
    </ly-table>
    <pay-detail
      :buttons="buttons"
      ref="payDetail"
      :def="defData"
      :class_id="defData.class_id"
      :sign_up_id="defData.id"
      :contact_id="defData.contact_id"
    />
  </div>
</template>

<script>
import { DatePicker, Input } from 'element-ui';
import LyTable from '@/components/LyTable';
import PayDetail from '@/components/PayDetail';
import { payDiscountTable } from '@/utils/tableHeader';
import { specializedSearchForm } from '@/utils/formConfigCommon';
import { finance } from '@/api';
import AdvancedQuery from '@/components/AdvancedQuery';
import utils from '@/utils/utils';

export default {
  name: 'PayDiscount',
  components: {
    LyTable,
    ElDatePicker: DatePicker,
    ElInput: Input,
    PayDetail,
    AdvancedQuery
  },
  data() {
    return {
      searchFormData: {},
      query: '',
      date: '',
      tableHeader: Object.freeze(payDiscountTable),
      getTableData: finance.discountQuery,
      searchFormConfig: {
        'label-width': '100px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 24
      },
      searchFormKeys: specializedSearchForm,
      defData: {
        class_id: 0,
        contact_id: 0,
        id: 0
      },
      buttons: []
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    exportExcel() {
      finance
        .exportDiscount({
          params: this.searchFormData
        })
        .then(data => {
          if (data) utils.downloadData(data, '订单列表');
        });
    },
    search(data) {
      const temp = !data || data.type ? {} : data;
      let pay_start_time;
      let pay_end_time;
      if (this.date && this.date.length) {
        [pay_start_time, pay_end_time] = this.date;
        temp.pay_start_time = pay_start_time;
        temp.pay_end_time = pay_end_time;
      }
      this.searchFormData = {
        ...data,
        ...temp,
        query: this.query
      };
      this.$refs.lyTable.setData();
    },
    openInf(row) {
      this.defData = { ...row };
      console.log(this.defData);
      this.$refs.payDetail.open();
    }
  }
};
</script>

<style lang="less">
.pay-discount {
  .hd {
    overflow: hidden;
    .fr {
      > .el-input {
        width: 230px;
        margin: 0 20px;
      }
      .el-range-editor {
        vertical-align: bottom;
        .el-range-separator {
          width: 22px;
        }
      }
    }
    .ly-search-comp {
      display: inline-block;
      margin: auto 5px;
    }
  }
  .el-button.reservation-number {
    white-space: normal;
    text-align: left;
  }
}
</style>
